export interface IReportSection {
    markerClassName: string;
    title: string;
    id: string;
}
